import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { CalendarClock, MapPin, Tag } from "lucide-react";

export default function Promotions() {
  const [promos, setPromos] = useState([]);
  useEffect(() => { api.get("/promotions").then((r) => setPromos(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <div className="mb-8">
        <span className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Bons plans</span>
        <h1 className="font-display text-3xl font-bold text-secondary mt-1">Promotions en cours</h1>
        <p className="text-muted-foreground">Profitez des meilleures offres avant la fin de validité.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {promos.map((p, i) => (
          <div key={p.promo_id} data-testid={`promo-${p.promo_id}`}
            className="rounded-xl overflow-hidden border border-border bg-card hover:-translate-y-1 transition-transform animate-fade-up" style={{ animationDelay: `${i * 50}ms` }}>
            <div className="relative h-44">
              {p.image_url ? <img src={p.image_url} alt={p.title} className="w-full h-full object-cover" /> : <div className="w-full h-full bg-muted flex items-center justify-center"><Tag className="w-10 h-10 text-muted-foreground/40" /></div>}
              {p.discount && <span className="absolute top-3 left-3 bg-primary text-white text-sm font-bold px-3 py-1 rounded-md shadow">{p.discount}</span>}
            </div>
            <div className="p-5">
              <h3 className="font-display font-bold text-secondary text-lg">{p.title}</h3>
              <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{p.description}</p>
              <div className="mt-3 flex items-center justify-between text-xs">
                <span className="text-accent font-medium flex items-center gap-1"><MapPin className="w-3 h-3" />{p.shop_name} · {p.city}</span>
              </div>
              {p.end_date && <div className="mt-2 text-xs text-muted-foreground flex items-center gap-1"><CalendarClock className="w-3 h-3" />Jusqu'au {p.end_date}</div>}
            </div>
          </div>
        ))}
      </div>
      {promos.length === 0 && <div className="text-center py-20 text-muted-foreground">Aucune promotion pour le moment.</div>}
    </div>
  );
}
